import { useCallback, useContext, useState } from 'react';

import { PartnerIntakeContext } from '@/Contexts/PartnerIntakeContext';

import IntakeAccreditedCheck from './IntakeAccreditedCheck';
import NotACollegeWarning from './NotACollegeWarning';
import ExistingPartnerSelect from '../common/ExistingPartnerSelect';
import NewPartnerSection from '../common/IntakeNewPartnerSection';
import NewPartnerSectionHeader from '../common/IntakeNewPartnerSectionHeader';
import IntakePrimaryContact from '../common/IntakePrimaryContact';
import IntakeShippingContact from '../common/IntakeShippingContact';
import IntakeSubmitButton from '../common/IntakeSubmitButton';
import NewPartnerCheckbox from '../common/NewPartnerCheckbox';
import PartnerCategoryInput from '../common/PartnerCategoryInput';
import PartnerNameInput from '../common/PartnerNameInput';
import { IntakeResponse } from '@/models/IntakeResponse';
import { ProgramProps } from '@/models/Program';

interface TreeCampusHigherEdSignUpProps {
  selectedProgramInfo: ProgramProps;
  onSubmit: (intakeResponse: IntakeResponse) => void;
}

function TreeCampusHigherEdSignUp({
  onSubmit,
  selectedProgramInfo,
}: TreeCampusHigherEdSignUpProps) {
  const { isNewPartner, disabledNewPartnerCheckbox } = useContext(PartnerIntakeContext);
  useContext(PartnerIntakeContext);
  const [institutionIsCollege, setInstitutionIsCollege] = useState<boolean | null>(null);

  const handleIsCollegeChange = useCallback((newValue: boolean | null) => {
    setInstitutionIsCollege(newValue);
  }, []);

  return (
    <>
      <IntakeAccreditedCheck isCollege={institutionIsCollege} onChange={handleIsCollegeChange} />

      {institutionIsCollege === false && <NotACollegeWarning />}
      {institutionIsCollege === true && (
        <>
          <IntakePrimaryContact />

          {!isNewPartner && <ExistingPartnerSelect />}

          {!disabledNewPartnerCheckbox && <NewPartnerCheckbox />}

          {isNewPartner && (
            <NewPartnerSection>
              <NewPartnerSectionHeader />

              {selectedProgramInfo.displayCategory && <PartnerCategoryInput />}

              <PartnerNameInput />

              <IntakeShippingContact />
            </NewPartnerSection>
          )}
          <IntakeSubmitButton onSubmit={onSubmit} />
        </>
      )}
    </>
  );
}

export default TreeCampusHigherEdSignUp;
